// read the docs here: https://v2.chakra-ui.com/docs/styled-system/customize-theme

import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';
import { components } from './components';

const customTheme = {
    colors,
    components,

    styles: {
        global: {
            '*': {
                // border: '1px solid',
            },
        },
    },
};

export default extendTheme(customTheme);
